<template>
<div id="container">
    <div class="container_wrap">
        <keep-alive>
            <knowledge-snb></knowledge-snb>
        </keep-alive>
        <router-view></router-view>
    </div>
</div>
</template>
<script>
import axios            from 'axios';
import SDLUtil          from '@/utils/SDLUtil';

import KnowledgeSnb     from './KnowledgeSnb';

export default {
    name: 'Knowledge',
    components : {
        'knowledge-snb'   : KnowledgeSnb,
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/Knowledge.vue